import { render, staticRenderFns } from "./Grab-retailer.vue?vue&type=template&id=06643f9b"
import script from "./Grab-retailer.vue?vue&type=script&lang=js"
export * from "./Grab-retailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports